module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2018/july-3c4cc584a96b2add6e13fcdff3a60d5f.png";